import React from "react";
import {
  Heart,
  Linkedin,
  Cookie,
  Shield,
  FileText,
  Globe,
  HelpCircle,
} from "lucide-react";
import { APP_VERSION } from "../version";

const Footer = ({
  onOpenPrivacy,
  onOpenTerms,
  onOpenCookieSettings,
  onOpenHelp,
}) => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-t-2 border-cyan-400/30 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-2">
            <h4 className="text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-cyan-400">
              Xunzhine
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed">
              Build better habits, track your progress, and achieve your goals —
              one day at a time.
            </p>
            <a
              href="https://www.xunzhine.in"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-cyan-300 hover:text-cyan-200 text-sm transition-colors"
            >
              <Globe className="w-4 h-4" />
              xunzhine.in
            </a>
          </div>

          {/* Help + legal */}
          <div className="space-y-2">
            <h5 className="text-sm font-semibold text-yellow-400 uppercase tracking-wide">
              Help &amp; legal
            </h5>
            <ul className="space-y-1.5">
              <li>
                <button
                  onClick={onOpenHelp}
                  className="inline-flex items-center gap-2 text-cyan-300 hover:text-cyan-200 text-sm font-semibold transition-colors"
                >
                  <HelpCircle className="w-4 h-4" />
                  How to use Xunzhine
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenPrivacy}
                  className="inline-flex items-center gap-2 text-gray-300 hover:text-cyan-300 text-sm transition-colors"
                >
                  <Shield className="w-4 h-4" />
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenTerms}
                  className="inline-flex items-center gap-2 text-gray-300 hover:text-cyan-300 text-sm transition-colors"
                >
                  <FileText className="w-4 h-4" />
                  Terms &amp; Conditions
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenCookieSettings}
                  className="inline-flex items-center gap-2 text-gray-300 hover:text-cyan-300 text-sm transition-colors"
                >
                  <Cookie className="w-4 h-4" />
                  Cookie settings
                </button>
              </li>
            </ul>
          </div>

          {/* Made by */}
          <div className="space-y-2 md:text-right">
            <h5 className="text-sm font-semibold text-yellow-400 uppercase tracking-wide">
              Crafted by
            </h5>
            <div className="flex items-center gap-2 md:justify-end text-cyan-300 text-sm">
              <span>Made with</span>
              <Heart className="w-4 h-4 text-red-400 fill-red-400 animate-pulse" />
              <span>by</span>
            </div>
            <a
              href="https://linkedin.com/in/sankar4"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-semibold text-yellow-400 hover:text-yellow-300 transition-colors group md:justify-end"
            >
              Sankar Balasubramanian
              <Linkedin className="w-4 h-4 group-hover:scale-110 transition-transform" />
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-6 border-t border-gray-700/60 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-500 text-xs">
            © {year} Xunzhine. All rights reserved.
          </p>
          <div className="flex items-center gap-3 text-xs text-gray-600">
            <span>v{APP_VERSION}</span>
            <span>•</span>
            <span>Build Better Habits</span>
            <span>•</span>
            <span>Track Your Progress</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
